import React, { useState } from 'react';
import Button from '../../components/UI/Button/Button';
import Classes from './style.css';
import Modal from '../../components/UI/Modal/Modal';
import { parseDateToReadable } from '../../utils';

export const EditBookingFound = ({
    partySize, visitTime, visitDate, canEdit, canCancel, editClicked, deleteClicked, translations,
    bookingCode, storeName
}) => {
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    return (
        <div className={Classes.ContentContainer}>
            <Modal
                show={isDeleteModalOpen}
                modalClosed={() => setIsDeleteModalOpen(false)}
                isFitToContent={true}
                dismissable={false}
                isFullScreen={true}
            >
                <div style={{ padding: '16px' }}>
                    <p className={Classes.LabelDeleteBooking}>{translations.label_message_delete_booking}</p>
                    <div className={Classes.DeleteModalButtonsContainer}>
                        <div className={Classes.DeleteModalButtonContainer}>
                            <Button
                                btnLabel={translations.label_cancel}
                                clicked={() => setIsDeleteModalOpen(false)}
                            />
                        </div>
                        <div className={Classes.DeleteModalButtonContainer}>
                            <Button
                                negative
                                btnLabel={translations.label_search_cancel_booking}
                                clicked={() => {
                                    setIsDeleteModalOpen(false);
                                    deleteClicked();
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
            <p
                className={Classes.BookingDetailsText}
                dangerouslySetInnerHTML={{
                    __html: translations.label_search_booking_recap
                        .replace("{0}", storeName)
                        .replace("{1}", parseDateToReadable(visitDate, translations))
                        .replace("{2}", visitTime)
                        .replace("{3}", partySize + ' ' + (partySize > 0 ? translations.label_people : translations.label_person))
                        .replace("{4}", bookingCode)
                }}
            >
            </p>
            <div className={Classes.ButtonsContainer}>
                {canEdit && <div className={Classes.ButtonContainer}>
                    <Button
                        btnLabel={translations.label_search_change_booking}
                        clicked={editClicked}
                    />
                </div>}
                {canCancel && <div className={Classes.ButtonContainer}>
                    <Button
                        negative
                        btnLabel={translations.label_search_cancel_booking}
                        clicked={() => setIsDeleteModalOpen(true)}
                    />
                </div>}
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/containers/EditBooking/EditBookingFound.js